import { useCallback, useState } from 'react';
import { TeamMemberDrawerStateProps } from 'components/organisms/module-settings/team-members/types';
import { Member } from 'data/members/api';

interface Result {
  drawerState: TeamMemberDrawerStateProps;
  changeToInviteMode: () => void;
  changeToViewMode: (member: Member) => void;
  changeToEditMode: (member: Member) => void;
  onClose: () => void;
}
export const useTeamMemberDrawerStateManager = (): Result => {
  const [teamMemberDrawerState, setTeamMemberDrawerState] =
    useState<TeamMemberDrawerStateProps>({
      visible: false,
      readOnly: false,
      selected: undefined,
    });

  const onClose = useCallback(() => {
    setTeamMemberDrawerState((prevState) => ({
      ...prevState,
      visible: false,
    }));
  }, []);

  const changeToInviteMode = useCallback(() => {
    setTeamMemberDrawerState({
      visible: true,
      readOnly: false,
      selected: undefined,
    });
  }, []);

  const changeToEditMode = useCallback((member: Member) => {
    setTeamMemberDrawerState({
      visible: true,
      readOnly: false,
      selected: member,
    });
  }, []);

  const changeToViewMode = useCallback((member: Member) => {
    setTeamMemberDrawerState({
      visible: true,
      readOnly: true,
      selected: member,
    });
  }, []);

  return {
    drawerState: teamMemberDrawerState,
    changeToInviteMode,
    changeToViewMode,
    changeToEditMode,
    onClose,
  };
};
